import React from "react"
import * as styles from "./vertical-spacing-small.module.scss"

export default function VerticalSpacingSmallRow(props) {
  return  <div className={styles.separator}></div>
}
